import type { TFunction } from 'i18next';

import type { CostEstimate } from '../types/cost-estimate.types';

/** "Requested by" or "Scheduled by", per how the run started. */
export function requesterCaption(estimate: CostEstimate, t: TFunction<'common'>): string {
  return estimate.triggerType === 'SCHEDULED'
    ? t('costEstimate.audit.scheduledBy')
    : t('costEstimate.audit.requestedBy');
}
